import { axios } from 'lib';
import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

const patch = ({ dID, name, value }) => {
  try {
    return axios.patch(
      `/api/directs/${dID}/field`,
      JSON.stringify({ name: name, value: value })
    );
  } catch (error) {
    return error;
  }
};

export const usePatchDirect = (refetch, message) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: patch,
    onSuccess: () => {
      enqueueSnackbar(message || 'Successfully updated', {
        variant: 'success',
        anchorOrigin: { horizontal: 'left', vertical: 'bottom' },
      });

      refetch();
    },
    onError: (error) => {
      console.log(error);
      enqueueSnackbar(error?.message || 'Some error occured', { variant: 'error' });
    },
  });
};
